import Loader from 'common/components/loader';
import { getAttributes } from 'pages/property/service';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { connect } from 'react-redux';

const AttributesContext = createContext('');

function AttributesProvider({ children }) {
  const [attributeOptions, setAttributeOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const getPropertyAttributes = async () => {
      // const cached = sessionStorage.getItem('MODAL_ATTRIBUTES');
      // if (cached) {
      //   setAttributeOptions(JSON.parse(cached));
      //   setIsLoading(false);
      //   return;
      // }

      const res = await getAttributes();
      setAttributeOptions(res);
      sessionStorage.setItem('MODAL_ATTRIBUTES', JSON.stringify(res));

      setIsLoading(false);
    };

    getPropertyAttributes();

    return () => setIsLoading(false);
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <AttributesContext.Provider
      value={{ attributeOptions, setAttributeOptions }}
    >
      {children}
    </AttributesContext.Provider>
  );
}

const mapStateToProps = state => {
  const { userDetail } = state.loginReducer;

  return { userDetail };
};
export const useAttributes = () => useContext(AttributesContext);
export default connect(mapStateToProps)(AttributesProvider);
